import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import {useDomainMonitorDelete} from 'features/domain/model/useDomainMonitorMutations';
import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import IDomainMonitorOutput from 'features/domain/model/DomainMonitor/IDomainMonitor';

interface IDomainMonitorDeleteModalProps {
    item: IDomainMonitorOutput,
    open: boolean;
    handleClose: () => void;
}

const DomainMonitorDeleteModal: React.FC<IDomainMonitorDeleteModalProps> = ({item, open, handleClose}) => {
    const {remove: onClickDelete, isLoading} = useDomainMonitorDelete({item, handleClose});

    return (
        <ConfirmModal
            variant="delete"
            open={open}
            handleClose={handleClose}
            header={t`Удаление монитора домена`}
            title={
                <Trans
                    id="modal.domainMonitor.delete.title"
                    message="Вы уверены, что хотите удалить монитор домена"
                />
            }
            name={item.domain_human_readable}
            hint={
                <Trans
                    id="modal.domainMonitor.delete.hint"
                    message="Вместе с монитором удалятся все инциденты этого домена."
                />
            }
            confirmText={t`Удалить`}
            onConfirm={onClickDelete}
            isLoading={isLoading}
        />
    );
};

export default DomainMonitorDeleteModal;
